import { get, patch, post, put } from '../../utils/http';

export const fetchPositions = ({ accountId }) => get(`/accounts/${accountId}/positions`);

export const addPosition = ({ accountId, position }) => post(`/accounts/${accountId}/positions`, position);

export const updatePositions = ({ accountId, positions }) => put(`/accounts/${accountId}/positions`, positions);

export const updatePosition = ({ accountId, positionId, position }) =>
  patch(`/accounts/${accountId}/positions/${positionId}`, position);
